module.exports = __webpack_public_path__ + "static/img/11.538999b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/11.jpg
// module id = L/fm
// module chunks = 1